var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btnGoback",style:(("float:" + _vm.float)),on:{"click":function($event){_vm.type === 'return' ? _vm.$router.go(-1) : _vm.handleClose()}}},[(_vm.type === 'return')?_c('i',{staticClass:"icon_arrow_left"}):_vm._e(),_vm._v(_vm._s(_vm.type === "return" ? "返回" : "关闭"))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68edb697","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Back.vue
// module id = null
// module chunks = 